import React from 'react'
import { Chart } from "react-google-charts";
import { shadeDefault } from '../InsightsColors';

const InsightLineGraphView =(props)=>{
    const {viewData, activeOption, onSelect} = props;

    const currentOption = activeOption;// || viewData.DefaultOption;
    
    // Remove trailing rows with all null/empty values (except header)
function replaceTrailingZerosWithNull(data) {
    if (!Array.isArray(data) || data.length < 2) return data;
    const result = data.map(row => [...row]);
    const numSeries = result[0].length - 1; // Exclude label column

    for (let col = 1; col <= numSeries; col++) {
        // Find last non-zero, non-null value for this series
        let lastIdx = result.length - 1;
        while (
            lastIdx > 0 &&
            (result[lastIdx][col] === 0 || result[lastIdx][col] === null || result[lastIdx][col] === undefined || result[lastIdx][col] === "")
        ) {
            lastIdx--;
        }
        // Replace trailing zeros with null
        for (let i = lastIdx + 1; i < result.length; i++) {
            result[i][col] = null;
        }
    }
    return result;
}

    if(viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].ChartData)
    {
        const rawData = viewData.ViewData[currentOption].ChartData;
        const chartData = replaceTrailingZerosWithNull(rawData);

        //console.log("layout response view", viewData.ViewData[currentOption].ChartData);

        const chartEvents = onSelect ? [
            {
                eventName: "select",
                callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length > 0) {
                        const { row, column } = selection[0];
                        // row: index of the data row (excluding header)
                        // column: index of the data column
                        const dataRow = chartData[row + 1]; // +1 because first row is header
                        const dataColName = chartData[0][column];
                        const value = dataRow ? dataRow[column] : null;
                        // Do something with row, column, value, dataColName, dataRow
                        onSelect({ row, column, value, dataColName, dataRow });
                    }
                }
            }
        ] : [];

        return (
            <Chart
                chartType="LineChart"
                data={chartData}
                options={{
                    title: "",
                    bars: "horizontal", // Required for Material Bar Charts.
                    bar: { groupWidth: "75%" },
                    legend: { position: "top" },
                    hAxis: { title: viewData.X_AXIS_Title },
                    vAxis: { title: viewData.ViewData[currentOption].Y_AXIS_Title },
                    colors: shadeDefault,
                    animation: {
                        duration: 1000,
                        easing: "out",
                    },
                }}
                chartEvents={chartEvents}
                width="100%"
                height="100%"
            />
        )
    }

    return null;
}

export default InsightLineGraphView
